
const getMessageIds = (sessionMessageData) => (
	sessionMessageData.keySeq().toArray()
);

const getMessageById = (sessionMessageData) => (messageId) => {
	return sessionMessageData.get(messageId);
}

export {getMessageIds, getMessageById}